class PlinkoGraphicBase {
  body: any
  Matter: any

  constructor(Matter: any, body: any) {
    this.Matter = Matter
    this.body = body
  }

  setup() {}

  destroy() {
    this.body = null
  }
}
export default PlinkoGraphicBase
